module.exports = __webpack_public_path__ + "img/button_background_company.b2ed18a4.png";